import { render, staticRenderFns } from "./ZhuYuanRecord.vue?vue&type=template&id=3709450a&scoped=true"
import script from "./ZhuYuanRecord.vue?vue&type=script&lang=js"
export * from "./ZhuYuanRecord.vue?vue&type=script&lang=js"
import style0 from "./ZhuYuanRecord.vue?vue&type=style&index=0&id=3709450a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3709450a",
  null
  
)

export default component.exports